export default {"src":"/_next/static/media/Loading.83605ad1.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};